import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router';
import { TalkDetailsConsumer } from '../../contexts/TalkDetailsContext';
import TalkInformation from './components/TalkInformation';
import './TalkDetail.scss';

export const TalkDetail = ({ isLoading, speakers, talks, loadTalkDetails }) => {
  const history = useHistory();
  const { talkId } = useParams();
  const details = talks.find(talk => talk.id === talkId) || {};
  const filteredSpeakers = speakers.filter(speaker => speaker.talks.includes(talkId));

  useEffect(() => {
    loadTalkDetails(talkId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="talk-details-section">
      <section className="section sp-form" id="talk-details">
        <div className="container sp-container">
          {!isLoading && !talks.some(talk => talk.id === talkId) ? (
            <h4 className="title is-4">Oops ! There is no such talk.</h4>
          ) : (
            <div className="card">
              {isLoading ? (
                <i className="fa fa-spinner fa-spin fa-3x fa-fw" style={{ color: '#7500c0' }} />
              ) : (
                <div>
                  <div className="columns is-multiline is-centered">
                    <TalkInformation
                      id={details.id}
                      liveCoding={details.livecoding || false}
                      proficiency={details.proficiency || ''}
                      speakers={filteredSpeakers}
                      summary={details.description || ''}
                      talkType={details.talkType || ''}
                      technicalOrBusiness={details.technicalOrBusiness || ''}
                      title={details.title || ''}
                      track={details.track}
                      video={details.youtube || ''}
                    />
                  </div>
                  <button
                    className="button is-large is-rounded btn-submit back-btn"
                    onClick={() => history.goBack()}
                    type="button">
                    Back
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

TalkDetail.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadTalkDetails: PropTypes.func.isRequired,
  speakers: PropTypes.arrayOf(PropTypes.any).isRequired,
  talks: PropTypes.arrayOf(PropTypes.any).isRequired
};

const TalkDetailContainer = props => (
  <TalkDetailsConsumer>
    {({ isLoading, speakers, talks, loadTalkDetails }) => (
      <TalkDetail
        isLoading={isLoading}
        loadTalkDetails={loadTalkDetails}
        speakers={speakers}
        talks={talks}
        {...props}
      />
    )}
  </TalkDetailsConsumer>
);

export default TalkDetailContainer;
